/* Alpha Everstrong - urun sayfasi satin alma kutusu.
   Varyant secimi, guc gostergesi, birim maliyet ve toplam tutar.
   Fiyat bicimi magazanin money_format ayarindan gelir. */
(function () {
  "use strict";

  function boot(root) {
    if (!root || root.dataset.alphaReady === "1") return;
    root.dataset.alphaReady = "1";

    var dataEl = root.querySelector("[data-alpha-variants]");
    if (!dataEl) return;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants = cfg.variants || [];
    var fmt = cfg.moneyFormat || "{{amount}}";
    var idInput = root.querySelector("[data-alpha-id]");
    var qtyInput = root.querySelector("[data-alpha-qty]");
    var elNow = root.querySelector("[data-alpha-price]");
    var elWas = root.querySelector("[data-alpha-compare]");
    var elSave = root.querySelector("[data-alpha-save]");
    var elPer = root.querySelector("[data-alpha-per]");
    var elTotal = root.querySelector("[data-alpha-total]");
    var elBtn = root.querySelector("[data-alpha-submit]");

    function group(n, decimals) {
      var s = (Math.round(n * 100) / 100).toFixed(decimals);
      var parts = s.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return decimals ? parts.join(",") : parts[0];
    }
    function money(cents) {
      var amount = cents / 100;
      if (/amount_no_decimals/.test(fmt)) {
        return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(amount, 0));
      }
      return fmt.replace(/\{\{\s*amount\s*\}\}/g, group(amount, 2));
    }

    function current() {
      var id = idInput && idInput.value;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return variants[0];
    }

    function qty() {
      var n = parseInt(qtyInput && qtyInput.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 99) n = 99;
      return n;
    }

    function render() {
      var v = current();
      if (!v) return;
      var q = qty();
      if (qtyInput) qtyInput.value = q;

      if (elNow) elNow.textContent = money(v.price);

      /* Karsilastirma fiyati yalnizca satis fiyatindan BUYUKSE gosterilir.
         Magazadaki compare_at degeri hatali (fiyattan dusuk) oldugu surece
         bu blok ve indirim rozeti hic basilmaz. */
      var validCompare = v.compare != null && v.compare > v.price;
      if (elWas) {
        elWas.textContent = validCompare ? money(v.compare) : "";
        elWas.hidden = !validCompare;
      }
      if (elSave) {
        if (validCompare) {
          var pct = Math.round((1 - v.price / v.compare) * 100);
          elSave.textContent = "%" + pct + " indirim";
          elSave.hidden = false;
        } else {
          elSave.hidden = true;
        }
      }

      /* Birim maliyet: sase adedi tanimli degilse satir tamamen gizlenir. */
      if (elPer) {
        if (v.units && v.units > 0) {
          elPer.innerHTML = v.units + " " + (cfg.unitNoun || "saset") +
            " · " + (cfg.unitLabel || "birim basina") + " <b>" +
            money(Math.round(v.price / v.units)) + "</b>";
          elPer.hidden = false;
        } else {
          elPer.hidden = true;
        }
      }

      if (elTotal) elTotal.textContent = money(v.price * q);

      if (elBtn) {
        elBtn.disabled = !v.available;
        var lbl = elBtn.querySelector("[data-alpha-label]");
        if (lbl) lbl.textContent = v.available ? (cfg.addLabel || "Sepete Ekle") : (cfg.soldLabel || "Tükendi");
      }

      root.querySelectorAll("[data-alpha-variant]").forEach(function (el) {
        el.classList.toggle("on", String(el.dataset.alphaVariant) === String(v.id));
      });
    }

    root.querySelectorAll("[data-alpha-variant] input[type=radio]").forEach(function (r) {
      r.addEventListener("change", function () {
        if (idInput) idInput.value = r.value;
        render();
      });
    });

    var minus = root.querySelector("[data-alpha-minus]");
    var plus = root.querySelector("[data-alpha-plus]");
    if (minus) minus.addEventListener("click", function () { qtyInput.value = Math.max(1, qty() - 1); render(); });
    if (plus) plus.addEventListener("click", function () { qtyInput.value = Math.min(99, qty() + 1); render(); });
    if (qtyInput) qtyInput.addEventListener("change", render);

    render();
  }

  function init() {
    document.querySelectorAll("[data-alpha-pdp]").forEach(boot);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
  document.addEventListener("shopify:section:load", function (e) {
    var r = e.target.querySelector("[data-alpha-pdp]");
    if (r) { r.dataset.alphaReady = ""; boot(r); }
  });
})();
